// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;Come and behold the works of the Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;what destruction he has wrought upon the earth.<br> </p> </div></div>";
// Exports
module.exports = code;